import * as z from "zod"
import { AccountType, SurchargeCategory, FreightService } from "@prisma/client"

export const ProviderModel = z.object({
  id: z.string(),
  created_at: z.date(),
  updated_at: z.date(),
  name: z.string(),
  logo_uri: z.string().nullish(),
  awb_prefix: z.string().nullish(),
  is_active: z.boolean(),
  allows_pelicargo_settled_payments: z.boolean(),
  direct_tracking_url: z.string().nullish(),
  terms_conditions_url: z.string().nullish(),
  supported_account_types: z.nativeEnum(AccountType).array(),
  required_surcharge_categories: z.nativeEnum(SurchargeCategory).array(),
  provided_services: z.nativeEnum(FreightService).array(),
  has_api_quoting: z.boolean(),
  has_api_booking: z.boolean(),
  has_api_cancellation: z.boolean(),
  has_api_booking_without_awb: z.boolean(),
})
